const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> June 30, 2025</p>
      <p>
        This Privacy Policy describes <strong>our policies and procedures</strong> on the collection, use, and disclosure of your information when you use the Service and tells you about your privacy rights and how the law protects you.
      </p>
      <p>
        We use your personal data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy.
      </p>

      <h2>1. Interpretation and Definitions</h2>
      <ul>
        <li><strong>Account:</strong> A unique account created for you to access our Service.</li>
        <li><strong>Affiliate:</strong> An entity that controls, is controlled by, or is under common control with a party.</li>
        <li><strong>Company:</strong> Refers to THE KARIGAR STOP PVT.LTD, Mumbai, Maharashtra.</li>
        <li><strong>Cookies:</strong> Small files placed on your device containing details of your browsing history.</li>
        <li><strong>Country:</strong> Maharashtra, India.</li>
        <li><strong>Device:</strong> Any device that can access the Service such as a computer, cellphone, or tablet.</li>
        <li><strong>Personal Data:</strong> Information that relates to an identified or identifiable individual.</li>
        <li><strong>Service:</strong> The Website.</li>
        <li><strong>Service Provider:</strong> Any party processing data on behalf of the Company.</li>
        <li><strong>Third-party Social Media Service:</strong> Any website or social network used for logging in or account creation.</li>
        <li><strong>Usage Data:</strong> Data collected automatically by using the Service.</li>
        <li><strong>Website:</strong> THE KARIGAR STOP, <a href="https://www.thekarigarstop.com" target="_blank" rel="noopener noreferrer">www.thekarigarstop.com</a></li>
        <li><strong>You:</strong> The individual accessing or using the Service, or the company/legal entity on whose behalf such individual is acting.</li>
      </ul>

      <h2>2. Collecting and Using Your Personal Data</h2>
      <h3><strong>Types of Data Collected</strong></h3>
      <h4>Personal Data</h4>
      <ul>
        <li><strong>Email address</strong></li>
        <li><strong>First name and last name</strong></li>
        <li><strong>Phone number</strong></li>
        <li><strong>Usage Data</strong></li>
      </ul>

      <h4>Usage Data</h4>
      <ul>
        <li>IP address, browser type/version, pages visited, time/date of visit, time spent on pages, unique device identifiers, and diagnostic data.</li>
        <li>If accessed through a mobile device, we may collect device type, unique ID, IP address, OS, browser type, and other diagnostic data.</li>
      </ul>

      <h4>Information from Third-Party Social Media Services</h4>
      <ul>
        <li>
          You may create an account and log in through:
          <ul style={{ listStyleType: "circle" }}>
            <li>Google</li>
            <li>Facebook</li>
            <li>Twitter</li>
          </ul>
        </li>
        <li>If you register or grant us access through a Third-Party Social Media Service, we may collect associated personal data (name, email, activities, contact list, etc.).</li>
        <li>You may share additional information via Third-Party Social Media Services during registration or otherwise.</li>
      </ul>

      <h4>Tracking Technologies and Cookies</h4>
      <ul>
        <li>
          <strong>Cookies or Browser Cookies:</strong> Small files on your device to remember your preferences or usage.
        </li>
        <li>
          <strong>Web Beacons:</strong> Electronic files in our Service or emails to count users, record popularity, and verify integrity.
        </li>
      </ul>
      <p>
        <strong>Cookies can be "Persistent" or "Session" Cookies.</strong> Persistent Cookies remain on your device when offline, while Session Cookies are deleted after closing your browser. Read more about cookies <a href="https://www.termsfeed.com/blog/cookies/#What_Are_Cookies" target="_blank" rel="noopener noreferrer">here</a>.
      </p>
      <ul>
        <li>
          <strong>Necessary / Essential Cookies</strong>
          <ul style={{ listStyleType: "circle" }}>
            <li>Type: Session Cookies</li>
            <li>Purpose: Essential for providing the Website and enabling features, authenticating users, and preventing fraud.</li>
          </ul>
        </li>
        <li>
          <strong>Cookies Policy / Notice Acceptance Cookies</strong>
          <ul style={{ listStyleType: "circle" }}>
            <li>Type: Persistent Cookies</li>
            <li>Purpose: Identify if users have accepted the use of cookies.</li>
          </ul>
        </li>
        <li>
          <strong>Functionality Cookies</strong>
          <ul style={{ listStyleType: "circle" }}>
            <li>Type: Persistent Cookies</li>
            <li>Purpose: Remember your preferences (login details, language) for a personal experience.</li>
          </ul>
        </li>
      </ul>

      <h3><strong>Use of Your Personal Data</strong></h3>
      <ul>
        <li><strong>To provide and maintain our Service:</strong> Including monitoring Service usage.</li>
        <li><strong>To manage your Account:</strong> Registering as a user, providing access to functionalities.</li>
        <li><strong>Performance of contract:</strong> Developing/completing purchases or other contracts via the Service.</li>
        <li><strong>To contact you:</strong> Email, phone, SMS, push notifications about updates, products/services, or security.</li>
        <li><strong>To provide you with offers:</strong> News, special offers, and information about similar goods or services unless you opt out.</li>
        <li><strong>To manage your requests:</strong> Responding to your inquiries.</li>
        <li><strong>For business transfers:</strong> Evaluating or conducting mergers, restructuring, sales, or transfer of assets.</li>
        <li><strong>For other purposes:</strong> Data analysis, usage trends, effectiveness of promotions, and improvements.</li>
      </ul>

      <h3><strong>Sharing Your Personal Information</strong></h3>
      <ul>
        <li><strong>With Service Providers:</strong> To monitor, analyze, or contact you.</li>
        <li><strong>For business transfers:</strong> During negotiations or completion of mergers, sales, or asset transfers.</li>
        <li><strong>With Affiliates:</strong> With parent or sister companies (subject to honoring this policy).</li>
        <li><strong>With business partners:</strong> To offer you certain products, services, or promotions.</li>
        <li><strong>With other users:</strong> If you share information publicly on the Service or interact via Third-Party Social Media Services.</li>
        <li><strong>With your consent:</strong> For any other purpose as authorized by you.</li>
      </ul>

      <h3><strong>Retention of Your Personal Data</strong></h3>
      <ul>
        <li>Your data is retained only as long as necessary for purposes set in this policy.</li>
        <li>We may retain Usage Data for internal analysis, security, or legal obligations.</li>
      </ul>

      <h3><strong>Transfer of Your Personal Data</strong></h3>
      <ul>
        <li>Your data may be transferred to—and maintained on—computers outside your jurisdiction where data protection laws may differ.</li>
        <li>We will take all steps to ensure your data is treated securely and in accordance with this policy.</li>
      </ul>

      <h3><strong>Delete Your Personal Data</strong></h3>
      <ul>
        <li>You may request deletion of your personal data collected by us.</li>
        <li>You may update, amend, or delete information anytime in your account settings.</li>
        <li>Some information may be retained as required by law.</li>
      </ul>

      <h3><strong>Disclosure of Your Personal Data</strong></h3>
      <ul>
        <li><strong>Business Transactions:</strong> In case of mergers, acquisitions, or sales, you will be notified before transfer.</li>
        <li><strong>Law enforcement:</strong> Disclosure if required by law or in response to valid government requests.</li>
        <li>
          <strong>Other legal requirements:</strong>
          <ul style={{ listStyleType: "circle" }}>
            <li>Comply with legal obligations</li>
            <li>Protect rights or property</li>
            <li>Prevent or investigate wrongdoing</li>
            <li>Protect safety of users/public</li>
            <li>Protect against legal liability</li>
          </ul>
        </li>
      </ul>

      <h3><strong>Security of Your Personal Data</strong></h3>
      <p>
        We use commercially acceptable means to protect your personal data, but no method of transmission or storage is 100% secure.
      </p>

      <h2>3. Children's Privacy</h2>
      <ul>
        <li>Our Service is not intended for anyone under age 13.</li>
        <li>We do not knowingly collect data from children under 13.</li>
        <li>If you are a parent/guardian and believe your child provided data, please contact us.</li>
        <li>If we learn data was collected from a child under 13 without parental consent, we will remove it.</li>
      </ul>

      <h2>4. Links to Other Websites</h2>
      <ul>
        <li>Our Service may contain links to non-operated third-party websites.</li>
        <li>We recommend reviewing the privacy policy of every third-party site you visit.</li>
        <li>We assume no responsibility for third-party content, policies, or practices.</li>
      </ul>

      <h2>5. Changes to this Privacy Policy</h2>
      <ul>
        <li>We may update this policy periodically and post changes on this page.</li>
        <li>You will be notified via email or a prominent notice on our Service before changes take effect.</li>
        <li>Review this policy regularly for changes. Changes are effective upon posting.</li>
      </ul>

      <h2>6. Contact Us</h2>
      <ul>
        <li>Email: thekarigarstop@gmail.com</li>
        <li>Phone: +91 9322883618</li>
      </ul>

      {/* Footer box (same as Terms of Service) */}
      <div
        style={{
          marginTop: "2.5rem",
          padding: "1.2rem 0",
          background: "#f6f1ff",
          textAlign: "center",
          color: "#5B2A93",
          borderRadius: 10,
          fontWeight: 500,
          fontSize: "1rem"
        }}
      >
        <span style={{ margin: "0 10px" }}>
          <a href="/terms-of-service" style={{ color: "#5B2A93" }}>Terms of Service</a>
        </span>
        |
        <span style={{ margin: "0 10px" }}>
          <a href="/privacy-policy" style={{ color: "#5B2A93" }}>Privacy Policy</a>
        </span>
        |
        <span style={{ margin: "0 10px" }}>
          <a href="/refund-cancellation-policy" style={{ color: "#5B2A93" }}>Refund & Cancellation Policy</a>
        </span>
        <br />
        <span style={{ color: "#888", fontSize: "0.85rem", fontWeight: 400 }}>
          &copy; {new Date().getFullYear()} THE KARIGAR STOP. All rights reserved.
        </span>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
